<script lang="ts">
	import { onMount } from 'svelte'

	import { browser } from '$app/environment'
	import { account } from '$lib/stores/account/account'

	export let clientId = ''
	export let autoSelect = false
	export let cancelOnTapOutside = false
	export let context = 'signin'
	export let callback = (r: any) => {}

	//console.log("========= googleOneTap... GO...")

	onMount(async () => {
		googleOneTap()
	})

	const googleOneTap = () => {
		if (!browser) return ''

		if (clientId === undefined || clientId === '') {
			console.log('client_id is required')
			throw new Error('client_id is required')
		}

		if ($account.registered) return ''

		if (typeof window !== 'undefined' && window.document) {
			const contextValue = ['signin', 'signup', 'use'].includes(context) ? context : 'signin'
			const googleScript = document.createElement('script')

			googleScript.src = 'https://accounts.google.com/gsi/client'
			googleScript.async = true
			googleScript.defer = true
			googleScript.type = 'text/javascript'
			document.head.appendChild(googleScript)

			googleScript.onload = function () {
				//console.log("========= googleOneTap... LOAD...")

				window.google.accounts.id.initialize({
					client_id: clientId,
					callback: callback,
					auto_select: autoSelect,
					cancel_on_tap_outside: cancelOnTapOutside,
					context: contextValue,
					...$$restProps
				})

				window.google.accounts.id.prompt((notification: any) => {
					console.log('one-tap notification', notification)
					//console.log("========= isNotDisplayed() ", notification.isNotDisplayed());
					//console.log("========= isSkippedMoment()", notification.isSkippedMoment());
					//console.log("========= getNotDisplayedReason()", notification.getNotDisplayedReason())
				})
			}
		}
	}

	//googleOneTap();
</script>
